import React from "react";
import DeleteIconV2 from "./DeleteIconV2";

interface MarketIndicatorProps {
  marketName: string;
  onclick: () => void;
  onDelete: () => void;
  activeMarket: string;
  totalOptions?: number;
  selectedOptions: number
}

const MarketIndicator: React.FC<MarketIndicatorProps> = ({ marketName, onclick, activeMarket, totalOptions = 12, selectedOptions,onDelete }) => {
  const progressPerc = (selectedOptions / totalOptions) * 100;
  return (
    <div onClick={onclick}

      className={`group relative w-[180px]  bg-white rounded-lg p-2.5 cursor-pointer
       flex-col justify-start items-start  overflow-hidden  ${activeMarket === marketName ? 'border-[1px] border-[#386ff5] bg-gradient-to-br from-[#d5e2ff] to-white' : 'border-[1px] border-[#e4e7ec] hover:bg-[#E4E7EC] hover:border-[#b1c3ff]'}`}
    >
       {/* Delete Icon */}
       {activeMarket !== marketName && <div
        onClick={(e) => {
          e.stopPropagation(); // Prevent tab switch
          onDelete();
        }}
        className="absolute top-2 right-2 hidden group-hover:flex items-center justify-center w-6 h-6 bg-white rounded-full shadow-sm hover:bg-gray-100"
      >
        {/* <DeleteOutlined className="text-[#667085] text-[12px]" /> */}
        <DeleteIconV2/>
      </div>}
      <div className="flex flex-col gap-2.5 p-[10px]">
        <div className={`justify-start ${activeMarket === marketName ? 'text-[#386ff5]' : 'text-[#1d2939]'}  text-[13px] font-normal font-['Inter'] leading-[19px]`}>{marketName}</div>
        <div className="inline-flex items-center justify-center gap-1.5">   <div className="relative w-full h-[4px] bg-[#e4e7ec] rounded-full">
          <div
            className="absolute top-0 left-0 h-full bg-[#1570EF] rounded-full"
            style={{ width: `${progressPerc}%` }}
          />
        </div>
          <div className="justify-start text-[#1d2939] text-[13px] font-normal font-['Inter'] leading-[19px]"> {selectedOptions}/{totalOptions}</div>


        </div>

      </div>
    </div>
  );
};

export default MarketIndicator;
